import { render, staticRenderFns } from "./FormIbanField.vue?vue&type=template&id=3f56a58a&scoped=true"
import script from "./FormIbanField.vue?vue&type=script&lang=js"
export * from "./FormIbanField.vue?vue&type=script&lang=js"
import style0 from "./FormIbanField.vue?vue&type=style&index=0&id=3f56a58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56a58a",
  null
  
)

export default component.exports